import React from "react";

function Score({ buttonStyle, selected, setFormData, formData, formRow }) {
  const handleParameterClick = (title, field, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [field]: value,
    }));
  };

  const parameters = [
    { title: "Gut Health", field: "gutHealth" },
    { title: "Energy", field: "energy" },
    { title: "Hair Loss", field: "hairLoss" },
    { title: "Hair Growth", field: "hairGrowth" },
  ];

  return (
    <div className="mt-4 mb-3">
      <h3 className='border-bottom border-1 pb-3'>Score on the following parameters</h3>
      <>
        {parameters.map((param) => (
          <div className="my-3" key={param.field}>
            <div className='d-flex align-itms-center justify-content-between border-bottom border-1 p-2'>
              <h4 className='flex-1 align-self-center p-0 m-0'>{param.title}</h4>

              <div className={`${formRow} flex-1 d-flex justify-content-between align-items-center`}>
                <p
                  onClick={() => handleParameterClick(param.title, param.field, 1)}
                  className={`flex-1 ${formData[param.field] === 1 ? selected : buttonStyle}`}
                >
                  Sad
                </p>
                <p
                  onClick={() => handleParameterClick(param.title, param.field, 5)}
                  className={`flex-1 ${formData[param.field] === 5 ? selected : buttonStyle}`}
                >
                  Indifferent
                </p>
                <p
                  onClick={() => handleParameterClick(param.title, param.field, 10)}
                  className={`flex-1 ${formData[param.field] === 10 ? selected : buttonStyle}`}
                >
                  Happy
                </p>
              </div>
            </div>
          </div>
        ))}
      </>

    </div>
  );
}

export default Score;
